import MessageAdListPreloadingStubElement from './components/MessageAdListPreloadingStubElement';
import { createLazyComponent, LazyModule } from 'owa-bundling';
import { runAfterInitialRender } from 'owa-delayed-initialization';
import * as React from 'react';
import { getNativeAdInitialPlacement } from 'owa-mail-ads-shared';
var messageAdListLazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "MessageAdList" */ './lazyIndex');
});
// Delay loaded components
export var MessageAdList = createLazyComponent(messageAdListLazyModule, function (m) { return m.MessageAdList; }, function () { return React.createElement(MessageAdListPreloadingStubElement, null); }, function () { } // Just ignore import errors
);
// Prefetch the module when the user is only on the native Ads flight
runAfterInitialRender(function () {
    if (getNativeAdInitialPlacement() != 0 /* None */) {
        messageAdListLazyModule.import();
    }
});
//# sourceMappingURL=index.js.map